const DASHBOARD_LOADING = "DASHBOARD_LOADING";
const DASHBOARD_SUCCESS = "DASHBOARD_SUCCESS";
const DASHBOARD_ERROR = "DASHBOARD_ERROR";

export {
    DASHBOARD_LOADING,
    DASHBOARD_ERROR,
    DASHBOARD_SUCCESS,
};